import {
  GET_TRACKING_PAGE_SUCCESS,
  GET_TRACKING_PAGE_FAILURE,
} from '../actions/asyncActions';

const initialState = {
  customerId: null,
  trackingPageName: null,
  createdOn: null,
  publishedOn: null,
  version: null,
  trackingPageData: {},
  shipments: null,
  trackingDataExists: false,
  requestFailed: false,
  isPreview: false,
  showPoweredByFooter: false,
};

/* eslint-disable-next-line default-param-last */
function trackingPage(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_TRACKING_PAGE_SUCCESS: {
      const {
        data: {
          trackingPage: {
            customerId,
            trackingPageName,
            createdOn,
            publishedOn,
            version,
            trackingPageData,
            showPoweredByFooter,
          },
          shipments,
        },
        isPreview,
      } = payload;
      return {
        customerId,
        trackingPageName,
        createdOn,
        publishedOn,
        version,
        trackingPageData,
        shipments,
        trackingDataExists: Boolean(shipments && shipments.length > 0),
        isPreview,
        showPoweredByFooter,
      };
    }
    case GET_TRACKING_PAGE_FAILURE: {
      const { response } = payload;
      return {
        ...state,
        // except errors that can be processed
        requestFailed: !response.notFound && !response.incorrectRequest,
      };
    }
    default:
      return state;
  }
}

export default trackingPage;
